<div class="d-flex align-items-center">
  <mat-icon color="warn" class="mr-2">error</mat-icon>
  <span *ngIf="message">{{message}}</span>
  <ul class="mb-0" *ngIf="messages.length">
    <li *ngFor="let msg of messages">{{msg}}</li>
  </ul>
</div>
